import { SET_ZENDESK_RETURN_TO_URL } from 'actions';

export default function setZendeskReturnToUrl(url) {
  return {
    type: SET_ZENDESK_RETURN_TO_URL,
    payload: url,
  };
}
